import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { withQuery } from '@panel/commons/core/themev2';
import { useBreakpoint } from '@panel/commons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Step4Module1 from './Module1';
import Step4Module3 from './Module3';
import { ProgressBox } from '../progressbox';
import { getProgressBoxConfig } from '../progressbox/config';
import { FeedbackBox } from '../feedbackbox';
import Step4Module2 from './Module2';
import { Step4Module1Selectors } from '../../ducks/step4Module1';
import { getWithUpgrade } from '../../utils/misc';

const Container = styled.div`
  display: block;
  width: 100%;
  padding: 0px 67px;
  margin-top: 40px;
  white-space: normal;
  min-height: 692px;
  ${withQuery.lg.down()} {
    padding: 0;
  }
  ${withQuery.md.down()} {
    padding: 0px 15px;
    margin-top: 0px;
    min-height: auto;
  }
  ${withQuery.sm.down()} {
    padding: 0px 15px;
    margin-top: 0px;
  }
  ${withQuery.xxs.down()} {
    padding: 0px;
    margin-top: 0px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 1440px;
  margin: 0px auto;
  white-space: normal;
  ${withQuery.lg.down()} {
    width: auto;
  }
  ${withQuery.sm.down()} {
    justify-content: center;
    margin: 0px auto;
  }
`;

const Aside = styled.div`
  flex: 0 1 20%;
`;

const ModuleContainer = styled.div`
  flex: 0 1 75%;
  max-width: 75%;
  margin: 0px auto;
  ${withQuery.lg.down()} {
    max-width: 100%;
    padding: 0;
  }
  ${withQuery.md.down()} {
    padding: 0px;
    margin: 0px;
    flex: none;
  }
  ${withQuery.xxs.down()} {
    padding: 0px;
    -webkit-flex: none;
    flex: none;
  }
`;

function Step4Container() {
  const [withUpgrade, setWithUpgrade] = useState(false);
  const [modules, setModules] = useState(getProgressBoxConfig(4));
  const { eligibleForUpgrade, products } = useSelector(Step4Module1Selectors.getStep4Module1State);
  const { t } = useTranslation();
  const [reachedBreakPoint] = useBreakpoint(1280);
  const params = useLocation().search;

  useEffect(() => {
    if (eligibleForUpgrade && products.length > 0 && !withUpgrade) {
      setWithUpgrade(getWithUpgrade(products));
    }
  }, [products, eligibleForUpgrade, withUpgrade]);

  useEffect(() => {
    if (eligibleForUpgrade && products.length > 0 && withUpgrade) {
      const newModules = modules.map((module, i) => {
        if (i === 0) module.title = t('publisher.step4.module1.upgrade.progressStepName');
        return module;
      });
      setModules(newModules);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibleForUpgrade, products]);

  return (
    <Container>
      <Wrapper>
        {modules && reachedBreakPoint && (
          <Aside data-repa='step3mod3-aside'>
            <ProgressBox modules={modules} />
            <FeedbackBox />
          </Aside>
        )}
        <Switch>
          <Route path='/publicador/planes' exact>
            <Redirect to={{ pathname: '/publicador/planes/seleccion', search: params }} />
          </Route>
          <Route path='/publicador/planes/seleccion'>
            <ModuleContainer>
              <Step4Module1
                back='extras'
                title={
                  eligibleForUpgrade && withUpgrade
                    ? t('publisher.step4.upgrade.mainTitle')
                    : t('publisher.step4.mainTitle')
                }
                eventName='Planes Modulo1'
                saveExit={false}
              />
            </ModuleContainer>
          </Route>
          <Route path='/publicador/planes/pago'>
            <ModuleContainer>
              <Step4Module2
                back='seleccion'
                step='planes'
                title={t('publisher.step4.mainTitle')}
                eventName='Planes Modulo2'
                saveExit={false}
              />
            </ModuleContainer>
          </Route>
          <Route path='/publicador/planes/vistaprevia'>
            <ModuleContainer>
              <Step4Module3
                back='seleccion'
                step='planes'
                title={t('publisher.step4.module3.mainTitle')}
                eventName='Planes Modulo3'
                saveExit={false}
              />
            </ModuleContainer>
          </Route>
        </Switch>
      </Wrapper>
    </Container>
  );
}

export default Step4Container;
